import React, { useEffect, useState } from 'react';

/**
 * Função que verifica se um email é válido.
 * @param {string} email - O email a ser verificado.
 * @returns {boolean} True se o email for válido, caso contrário, false.
 */
const checkIfIsEmailValid = (email) => {
	return email.match(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i) === null;
};

/**
 * Componente que verifica a validade de um ou mais emails.
 * @param {object} props - Propriedades do componente.
 * @param {object} props.emailsConfig - Configurações dos emails a serem verificados.
 * @param {string} props.emailsConfig.email - O email principal a ser verificado.
 * @param {string} props.emailsConfig.emailConfirmation - O email de confirmação, se disponível.
 * @param {boolean} props.emailsConfig.isActive - Indica se o componente está ativo.
 * @param {boolean} props.emailsConfig.isEmailsMatchs - Indica se os emails correspondem (opcional).
 * @param {(isValid: boolean) => void} props.onValid - Função de retorno de chamada para indicar se os emails são válidos.
 * @returns {JSX.Element} O componente de verificação de emails.
 */
const CheckEmails = ({ emailsConfig, onValid }) => {
	const [visible, setVisible] = useState(false);
	const [isValid, setIsValid] = useState(false);

	useEffect(() => {
		const { email, emailConfirmation, isActive, isEmailsMatchs } = emailsConfig;
		setVisible(isActive);
		if (email.length === 0) return;

		setIsValid(!checkIfIsEmailValid(email) && !checkIfIsEmailValid(emailConfirmation));

		if (isValid && isEmailsMatchs) {
			onValid?.(true);
		} else {
			onValid?.(false);
		}
	}, [emailsConfig, isValid, onValid]);
	return <></>;
};

export default CheckEmails;
